export default "__VITE_ASSET__OI1uYKTV__"